import React from 'react'
import { Link } from "react-router-dom";

const HybridSolarPowerPlant = () => {
  return (
    <>

      <div className="page-header dark-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="A Complete Guide to Solar Energy ..." style={{ perspective: 400 }}>
                  <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                    <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                      Hybrid Solar Power Plant
                    </div>
                  </div>
                </h1>
                <div className="post-single-meta wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <ol className="breadcrumb">
                    <a to='/'> <li><i className="fa-regular fa-user" /> Home</li></a>
                    <li><i className="fa-regular fa-clock" /> Hybrid Solar Power Plant</li>
                  </ol>
                </div>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>

      <div className="page-service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              {/* Page Single Sidebar Start */}
              <div className="page-single-sidebar">
                {/* Page Category List Start */}
                <div className="page-category-list wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <h2 className="page-category-list-title">Explore Our Services</h2>
                  <ul>
                    <li><Link to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></li>
                    <li><Link to="/solar-electrical-installation">Solar & Electrical Installation</Link></li>
                    <li><Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></li>
                    <li><Link to="/solar-water-heater-solution">Solar Water Heater Solution</Link></li>
                    <li><Link to="/EV-charging-solution">EV Charging Solution</Link></li>
                    <li><Link to="/solar-water-pump-solution">Solar Water Pump Solution</Link></li>
                  </ul>
                </div>
                {/* Page Category List End */}
                {/* Sidebar CTA Box Start */}
                <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                  <div className="sidebar-cta-header">
                    <div className="icon-box">
                      <img src="./assets/images/icon-headphone-white.svg" alt />
                    </div>
                    <div className="sidebar-cta-image">
                      <figure>
                        <img src="./assets/images/sidebar-cta-image.png" alt />
                      </figure>
                    </div>
                  </div>
                  <div className="sidebar-cta-body">
                    <h2>Contact Us For a Quote</h2>
                    <ul>
                      <li>Call Us: <a href="tel:+91 9516839231">+91 9516839231</a></li>
                    </ul>
                  </div>
                </div>
                {/* Sidebar CTA Box End */}
              </div>
              {/* Page Single Sidebar End */}
            </div>
            <div className="col-lg-8">
              {/* Service Single Content Start */}
              <div className="service-single-content">
                {/* Page Single Image Start */}
                <div className="page-single-image">
                  <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                    <img src="./assets/images/service-item-image-1.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                  </figure>
                </div>
                {/* Page Single Image End */}
                {/* Service Entry Start */}
                <div className="service-entry">
                  <div className="service-offer-box">
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Smart & Reliable Solar Energy with Battery Backup
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>A Hybrid Solar Power Plant combines solar energy generation with battery storage and, where required, the conventional electricity grid. This integrated approach allows solar power to be used efficiently while stored energy can provide backup when solar generation is insufficient.</p>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>At Solar World Enterprises, we provide customized hybrid solar solutions for homes, businesses, industries, farms, institutions, and other applications. Our systems are designed according to energy consumption, backup requirements, available installation space, and site conditions.</p>
                    {/* Service Offer Box List Start */}
                    {/* <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li>Improve energy independence &amp; reliability</li>
                        <li>Backup power during grid outages</li>
                        <li>Smart energy management &amp; monitoring</li>
                        <li>Lower electricity bills using store energy</li>
                      </ul>
                    </div> */}
                  </div>
                  {/* Service Offer Box End */}
                  {/* Service Key Benefits Start */}
                  <div className="service-key-benefits">
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          How a Hybrid Solar Power Plant Works
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>During sunlight hours, solar panels generate electricity to supply connected loads. Depending on the system configuration, excess solar energy can be stored in batteries for later use. When solar generation is insufficient, the system can draw energy from the battery and/or the grid.</p>
                    
                    <div className="service-key-benefits-body">
                      {/* Service Benefits Image Start */}
                      <div className="service-benefit-image">
                        <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                          <img src="./assets/images/service-benefit-image.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                        </figure>
                      </div>
                      {/* Service Benefits Image End */}
                      {/* Service Benefits Item List Start */}
                      <div className="service-benefit-item-list">
                        {/* Service Benefits Item Start */}
                        <div className="service-benefit-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                          <div className="icon-box">
                            <img src="./assets/images/icon-service-benefit-1.svg" alt />
                          </div>
                          <div className="service-benefit-item-content">
                            <h3>Our Hybrid Solar Services</h3>
                            <p><b>Site Survey → Energy Assessment → System Design → Equipment Selection → Installation → Battery & Inverter Integration → Testing → Commissioning → Maintenance & Support</b></p>
                            <h3>Why Choose Solar World Enterprises?</h3>
                            <p>We focus on providing properly designed and professionally installed hybrid solar systems tailored to each customer's requirements. From initial consultation and system planning to installation and after-sales support, our team aims to provide a smooth and dependable solar experience.</p>
                          </div>

                        </div>
                      </div>
                      {/* Service Benefits Item List End */}
                    </div>

                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', marginTop: "20px" }}>
                          Key Benefits
                        </div>
                      </div>
                    </h2>
                    <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li><b> ☀️ Efficient Solar Utilization :</b>  Makes productive use of electricity generated from sunlight.</li>
                        <li><b> 🔋 Battery Backup:</b> Stored energy can support loads when solar generation is unavailable. </li>
                        <li><b> ⚡ Greater Energy Reliability:</b> Provides multiple energy sources for improved power availability. </li>
                        <li><b>💰 Potential Energy Savings :</b>  Helps reduce dependence on conventional grid electricity.</li>
                        <li><b> 🌱 Clean Energy Solution:</b>  Supports increased use of renewable solar power.</li>
                        <li><b> 🏠 Flexible Applications:</b> Suitable for residential, commercial, industrial, agricultural, and institutional projects. </li>
                        <li><b> 📈 Scalable Design:</b> Systems can be planned according to current and future energy requirements. </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default HybridSolarPowerPlant